import React from 'react';
import styled from 'styled-components';

import { Feedback } from '@shared/constants/feedback';
import { FeedbackCard } from '@components/molecules';

type CarouselItemProps = {
  index: number;
  isCenter: boolean;
  sideWidth: number;
  centerWidth: number;
  isTransitioning: boolean;
  feedback: Feedback;
};

export default function CarouselItem({
  index,
  isCenter,
  sideWidth,
  centerWidth,
  isTransitioning,
  feedback,
}: CarouselItemProps) {
  return (
    <StyledDiv
      key={index}
      $isCenter={isCenter}
      $sideWidth={sideWidth}
      $centerWidth={centerWidth}
      $transition={isTransitioning}
    >
      <FeedbackCard
        lineHeight={isCenter ? undefined : 20}
        fontSize={isCenter ? undefined : 16}
        isCenter={isCenter}
        {...feedback}
      />
    </StyledDiv>
  );
}

const StyledDiv = styled.div<{
  $isCenter: boolean;
  $transition: boolean;
  $sideWidth: number;
  $centerWidth: number;
}>`
  display: flex;
  border-radius: 16px;

  width: ${({ $isCenter, $sideWidth, $centerWidth }) =>
    $isCenter ? $centerWidth : $sideWidth}px;

  height: ${({ $isCenter }) => ($isCenter ? 398 : 300)}px;

  transition: ${({ $transition }) => ($transition ? 'height 100ms' : 'none')};
`;
